import '../../Styles/serviceComponenetsStyles/contact.css';
import address from '../../Assets/address.png';
import email from '../../Assets/mail-inbox.png'
import phone from '../../Assets/phone.png'
import insta from '../../Assets/instagram.png';
import twitter from '../../Assets/twitter.png';
import fb from '../../Assets/facebook.png';

export default function Contact() {
  return (
    <div className='contact'>
        <div className="contactContainer">
            <div className="contactTop">
                <div className="contactheading">CONTACT US</div>
                <div className="contactDetailsContainer">
                    <div className="contactdetails">
                        <div className="address">
                            <div className="addressicon icon">
                                <img src={address} alt="addressimage" />
                            </div>
                            <div className="addressText">
                                Thiruvanchoor Temple Rd, near Naalumanikkattu, Thiruvanchoor,<br/>
                                Manarcadu, Kerala 686019
                            </div>
                        </div>
                        <div className="email">
                            <div className="emailicon icon">
                                <img src={email} alt="emailinbox" />
                            </div>
                            <div className="emailtxt">
                                supixsoftwarecompany@gmail.com
                            </div>
                        </div>
                        <div className="phone">
                            <div className="phoneIcon icon">
                                <img src={phone} alt="phoneImg" />
                            </div>
                            <div className="phoneTxt">
                                +916282351067 , +919544987714
                            </div>
                        </div>
                        <div className="follow">
                            <div className="followicon">
                                <img src={insta} alt="" />
                            </div>
                            <div className="followicon">
                                <img src={twitter} alt="" />
                            </div>
                            <div className="followicon">
                                <img src={fb} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="lineContainer">
                    <div className="Contactline"></div>
                </div>
                <div className="Getintouch">
                    <div className='head'>GET IN TOUCH</div>
                    <div className='inputContainers'>
                        <div className='firstSection'>
                            <div className='row1'>
                                <input type="text" />
                                <span>First name</span>
                            </div>
                            <div>
                                <input type="text" />
                                <span>email</span>
                            </div>
                        </div>
                        <div className='firstSection'>
                            <div>
                                <input type="text" />
                                <span>last name</span>
                            </div>
                            <div>
                                <input type="text" />
                                <span>phone</span>
                            </div>
                        </div>
                        <div className='firstSection'>
                            <div className='textarea'>
                                <textarea name="" id="" cols="30" rows="10"></textarea>
                                <span>feedback</span>
                            </div>
                        </div>
                    </div>
                    <div className='sendDiv'>
                        <button className='send'>send</button>
                        </div>
                </div>
            </div>
        </div>
    </div>
  )
}
